var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 16 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.421.413c.182-.55.976-.55 1.158 0l1.471 4.446a.61.61 0 0 0 .58.413h4.76c.59 0 .835.74.358 1.081l-3.852 2.748a.59.59 0 0 0-.22.668l1.47 4.446c.182.55-.46 1.008-.937.668l-3.851-2.747a.62.62 0 0 0-.716 0l-3.851 2.747c-.478.34-1.12-.117-.937-.668l1.47-4.446a.59.59 0 0 0-.22-.668L.252 6.353C-.225 6.013.02 5.272.61 5.272h4.76a.61.61 0 0 0 .58-.413z"
  })));
};
export default SvgStar;